module.exports = __webpack_public_path__ + "static/media/cloudy-night-1.7e65840b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/cloudy-night-1.svg
// module id = 513
// module chunks = 0